var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentDownloadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6891_5515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99719 12.1755C8.99719 12.0242 8.99719 11.9256 8.99719 11.8335C8.99719 8.30835 8.99094 4.78319 9.00344 1.25803C9.00344 1.00812 9.05342 0.725314 9.16589 0.50828C9.36583 0.10052 9.82193 -0.0704768 10.253 0.0413285C10.6529 0.13998 10.9528 0.50828 10.9966 0.955502C11.0091 1.08046 11.0091 1.19884 11.0091 1.3238C11.0091 4.82265 11.0091 8.32808 11.0091 11.8269C11.0091 11.9256 11.0091 12.0177 11.0091 12.1886C11.109 12.09 11.1715 12.0308 11.2277 11.9716C12.2337 10.9128 13.2334 9.85389 14.2393 8.79503C14.533 8.48592 14.8641 8.34781 15.2765 8.46619C15.9763 8.67007 16.2449 9.55793 15.7888 10.1498C15.7326 10.2222 15.6701 10.2814 15.6139 10.3471C14.0206 12.0242 12.4211 13.7079 10.8279 15.385C10.278 15.9637 9.73446 15.9571 9.18463 15.3784C7.56014 13.6684 5.94814 11.9716 4.3424 10.2748C3.97376 9.88677 3.89879 9.40009 4.11747 8.9726C4.44237 8.34123 5.21712 8.22285 5.72946 8.74241C6.22931 9.24883 6.71041 9.77497 7.204 10.2945C7.73509 10.8536 8.25992 11.4126 8.79101 11.9716C8.84099 12.0242 8.89722 12.0768 8.99719 12.1755Z",
    fill: "#343A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97814 20.0018C6.98533 20.0018 3.99876 20.0018 1.00595 20.0018C0.537344 20.0018 0.124973 19.6664 0.0250045 19.2126C-0.0812123 18.7325 0.118725 18.2458 0.531096 18.0287C0.687298 17.9498 0.874739 17.8972 1.04344 17.8972C7.01032 17.8906 12.971 17.8906 18.9378 17.8906C19.5502 17.8906 19.9938 18.351 19.9938 18.9626C19.9875 19.5743 19.5439 20.0018 18.9191 20.0018C15.945 20.0018 12.9585 20.0018 9.97814 20.0018Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6891_5515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentDownloadImg);
export default __webpack_public_path__ + "static/media/attachment-download-img.3f5acc526d003fb5976eb678e2505799.svg";
export { ForwardRef as ReactComponent };